import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { Button } from "../ui/button";
import TutorialViewer from "./TutorialViewer";
import { useLang } from "../../i18n/LangContext";

/**
 * Inline "How to use" button — drop inside any tool header.
 *
 *   <HelpButton tutorialId="watchlist" />
 *
 * Renders a compact ghost button that opens the tutorial modal.  Because the
 * modal is portal-mounted, the underlying page state (filters, form data,
 * scroll position) is preserved when the user closes it.
 */
export default function HelpButton({ tutorialId, variant = "ghost", size = "sm", className = "" }) {
  const [open, setOpen] = useState(false);
  const { t } = useLang();
  if (!tutorialId) return null;
  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setOpen(true)}
        title={t("tut.help.tooltip")}
        data-testid={`help-button-${tutorialId}`}
        className={`gap-1.5 text-slate-600 hover:text-slate-900 dark:text-slate-300 ${className}`}>
        <HelpCircle className="w-4 h-4" />
        <span className="text-xs">{t("tut.help.button")}</span>
      </Button>
      <TutorialViewer
        tutorialId={tutorialId}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
